export const stringToJson = (stringData: string) => {
  var newJson = stringData.replace(/([a-zA-Z0-9]+?):/g, '"$1":');
  newJson = newJson.replace(/'/g, '"');
  return JSON.parse(newJson);
}

export const replaceBetween = (text,start, end, what) => {
  return text.substring(0, start) + what + text.substring(end);
};